import React from 'react';
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { FiArrowLeft, FiFlag } from "react-icons/fi";
import { BsFillXCircleFill, BsCheckCircleFill } from "react-icons/bs";
import "./CSRDUpsale.scss";
import GRI_report from '../images/GRI_report.png';
import GRI_copilot from '../images/GRI_copilot.png';

const CSRDUpsale = ({ t }) => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/company_admin/home");
  };

  const handleUpgrade = () => {
    // Navigate to upgrade page or show upgrade modal
    navigate("/company_admin/upgrade");
  };

  return (
    <div className="saas-upgrade-page" data-testid="saas-upgrade-page">
    {/* Top Section - Light gray background with two columns */}
    <section className="top-section">
      <div className="container">
        <div className="row align-items-center m-0">
          {/* Left Column - Text Content */}
          <div className="col-lg-5">
            <h1 className="section-title mb-4" data-testid="top-section-title">
              {t("SaaSUpgrade.topSection.title.label")}
            </h1>

            <p className="mb-4">
              {t("SaaSUpgrade.topSection.description.label")}
            </p>
            <div className="mb-4">
              <b>
                {t("SaaSUpgrade.topSection.upgradeNotice.label")}
              </b>
            </div>
            <div className="button-group" data-testid="button-group">
              <button
                className="btn btn-primary "
                onClick={handleUpgrade}
                data-testid="upgrade-button"
              >
                {t("SaaSUpgrade.topSection.contactUpgrade.label")}
              </button>
              <button
                className="btn btn-outline-secondary home-btn"
                onClick={handleBackToHome}
                data-testid="upgrade-btn"
              >
                {t("SaaSUpgrade.topSection.goToHome.label")}
              </button>
             
            </div>
          </div>
          <div className="col-lg-7">
            <div className="text-center">
              <div className="reporting-studio-image  ">
                <img
                  src={GRI_report}
                  alt={t("SaaSUpgrade.topSection.reportingStudio.alt.label")}
                  className="img-fluid"
                  data-testid="reporting-studio-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Middle Section - Two columns with image and benefits */}
    <section className="middle-section py-5">
      <div className="container">
        <div className="row align-items-center m-0">
          {/* Left Column - Image */}
          <div className="col-lg-6 ">
            <div className="text-center">
              <div className="ai-copilot-image ">
                <img
                  src={GRI_copilot}
                  alt={t("SaaSUpgrade.middleSection.aiCopilot.alt.label")}
                  className="img-fluid w-50"
                  data-testid="ai-copilot-image"
                />
              </div>
            </div>
          </div>

          {/* Right Column - Benefits */}
          <div className="col-lg-6">
            <h2 className="section-title mb-4">
              {t("SaaSUpgrade.middleSection.title.label")}
            </h2>
            <div className="benefits-list">
              <div className="benefit-item d-flex align-items-start mb-3">
                <FiFlag className="text-success me-3 mt-1 flex-shrink-0" size={20} />
                <div>
                  <strong>{t("SaaSUpgrade.middleSection.benefit1.title.label")}</strong> – {t("SaaSUpgrade.middleSection.benefit1.description.label")}
                </div>
              </div>
              <div className="benefit-item d-flex align-items-start mb-3">
                <FiFlag className="text-success me-3 mt-1 flex-shrink-0" size={20} />
                <div>
                  <strong>{t("SaaSUpgrade.middleSection.benefit2.title.label")}</strong> – {t("SaaSUpgrade.middleSection.benefit2.description.label")}
                </div>
              </div>
              <div className="benefit-item d-flex align-items-start mb-3">
                <FiFlag className="text-success me-3 mt-1 flex-shrink-0" size={20} />
                <div>
                  <strong>{t("SaaSUpgrade.middleSection.benefit3.title.label")}</strong> – {t("SaaSUpgrade.middleSection.benefit3.description.label")}
                </div>
              </div>
              <div className="benefit-item d-flex align-items-start mb-3">
                <FiFlag className="text-success me-3 mt-1 flex-shrink-0" size={20} />
                <div>
                  <strong>{t("SaaSUpgrade.middleSection.benefit4.title.label")}</strong> – {t("SaaSUpgrade.middleSection.benefit4.description.label")}
                </div>
              </div>
              <div className="benefit-item d-flex align-items-start mb-3">
                <FiFlag className="text-success me-3 mt-1 flex-shrink-0" size={20} />
                <div>
                  <strong>{t("SaaSUpgrade.middleSection.benefit5.title.label")}</strong> – {t("SaaSUpgrade.middleSection.benefit5.description.label")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Bottom Section - Comparison Table */}

    <section className="bottom-section ">
        <div className="container px-4">
          <div className='mb-3'>
            <h4 className="step-up-title fw-bold" data-testid="step-up-title">
              Step Up Your Plan
            </h4>
          </div>

          <div className='row m-0 OurPlansSection'>
            <div className='col-md-6 p-2'>
              <div className='OurPlansSection_List'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>{t("OurPlans.label")}</h6>
                  </li>
                  <li>
                    <h6 className='m-0'> {t("brsr.bottomSection.table.frameworkcoverage.label")}</h6>
                    <p> {t("brsr.bottomSection.table.frameworkcoverage.upgradeplan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("brsr.bottomSection.table.reportbuilder.label")}</h6>
                    <p> {t("brsr.bottomSection.table.reportbuilder.upgradeplan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("brsr.bottomSection.table.datalink.label")}</h6>
                    <p>{t("brsr.bottomSection.table.datalink.upgradeplan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("brsr.bottomSection.table.exportoptions.label")}</h6>
                    <p> {t("brsr.bottomSection.table.exportoptions.upgradeplan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("brsr.bottomSection.table.aiSupport.label")}</h6>
                    <p> {t("brsr.bottomSection.table.aiSupport.upgradeplan.label")}</p>
                  </li>
                  <li>
                    <h6 className='m-0'>{t("brsr.bottomSection.table.collaboration.label")}</h6>
                    <p> {t("brsr.bottomSection.table.collaboration.upgradeplan.label")}</p>
                  </li>

                </ul>
              </div>
            </div>
            <div className='col-md-3 p-2'>
              <div className='OurPlansSection_List Current-planList'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>
                      {t("GolasKpisUpsale.bottomSection.table.currentPlan.label")}
                    </h6>
                  </li>
                  <li>
                    <p>{t("brsr.bottomSection.table.frameworkcoverage.currentplan.label")}</p>
                  </li>
                  <li>
                    <p>{t("brsr.bottomSection.table.reportbuilder.currentplan.label")}</p>
                  </li>
                  <li>
                    <p>{t("brsr.bottomSection.table.datalink.currentplan.label")}</p>
                  </li>
                  <li>
                    <p>{t("brsr.bottomSection.table.exportoptions.currentplan.label")}</p>
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>
                  <li>
                    <BsFillXCircleFill className='text-danger' />
                  </li>

                </ul>
              </div>
            </div>
            <div className='col-md-3 p-2'>
              <div className='OurPlansSection_List Current-planList'>
                <ul>
                  <li className='OurPlansSection_List_Header'>
                    <h6 className='mb-0'>
                      {t("GolasKpisUpsale.bottomSection.table.upgradedPlan.label")}
                    </h6>
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li>
                    <BsCheckCircleFill className='text-success' />
                  </li>
                  <li> <BsCheckCircleFill className='text-success' /></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="button-group text-right p-2" data-testid="button-group">
            <a
              href="mailto:info@ecodrisil.com"
              className="btn btn-primary upgrade-btn"
            >
              {t("GolasKpisUpsale.topSection.upgradeButton.label")}
            </a>
          </div>

        
        </div>
      </section>

  
  </div>
  );
};

export default withTranslation()(CSRDUpsale);
